import { DateUtility } from 'utility'
import { AUDITOR_SUMMARY_DEFAULT_TARGET } from './constants'

export const readField = (obj, pascal, camel) => {
    if (!obj) return undefined
    if (obj[pascal] !== undefined) return obj[pascal]
    if (camel && obj[camel] !== undefined) return obj[camel]
    return undefined
}

export const toIdArray = value => {
    if (!Array.isArray(value)) return []
    return value
        .map(item => Number(item))
        .filter(item => Number.isInteger(item) && item > 0)
}

export const formatYmd = value => {
    if (!value) return null
    return DateUtility.dateToLocalISO(value, 'yyyy-MM-dd')
}

export const clampTargetPct = value => {
    const n = Number(value)
    if (Number.isNaN(n)) return AUDITOR_SUMMARY_DEFAULT_TARGET
    return Math.min(100, Math.max(0, Math.round(n)))
}

export const getPctTone = (value, targetPct = AUDITOR_SUMMARY_DEFAULT_TARGET) => {
    if (value === null || value === undefined || value === '') return 'blank'
    const pct = Number(value)
    if (Number.isNaN(pct)) return 'blank'
    const target = clampTargetPct(targetPct)
    if (pct >= target) return 'ok'
    if (pct >= target - 10) return 'amber'
    return 'bad'
}

export const formatPct = value => {
    if (value === null || value === undefined || value === '') return null
    const n = Number(value)
    if (Number.isNaN(n)) return null
    const rounded = Math.round(n * 10) / 10
    return Number.isInteger(rounded) ? `${rounded}%` : `${rounded.toFixed(1)}%`
}

export const formatExcelExpiry = value => {
    if (!value) return ''
    const formatted = DateUtility.dateToLocalISO(value, 'dd/MM HH:mm')
    return formatted ? `válido hasta ${formatted}` : ''
}

export const formatGeneratedAt = value => {
    if (!value) return '—'
    return DateUtility.dateToLocalISO(value, 'yyyy-MM-dd HH:mm') || '—'
}

export const formatRangeLabel = (fromDate, toDate, months) => {
    if (Array.isArray(months) && months.length > 0) {
        const first = months[0]?.Label || months[0]?.label
        const last =
            months[months.length - 1]?.Label || months[months.length - 1]?.label
        if (first && last) {
            return first === last ? first : `${first} – ${last}`
        }
    }
    const from = formatYmd(fromDate)
    const to = formatYmd(toDate)
    if (from && to) return `${from} → ${to}`
    if (from) return `Desde ${from}`
    if (to) return `Hasta ${to}`
    return 'Todo el historial'
}

export const averageNumbers = values => {
    const nums = (values || [])
        .map(value => Number(value))
        .filter(value => !Number.isNaN(value))
    if (!nums.length) return null
    return nums.reduce((sum, n) => sum + n, 0) / nums.length
}

export const sumByIndex = (rows, getList, index) =>
    (rows || []).reduce((sum, row) => {
        const list = getList(row) || []
        const n = Number(list[index])
        return sum + (Number.isNaN(n) ? 0 : n)
    }, 0)

export const sumTotals = (rows, getTotal) =>
    (rows || []).reduce((sum, row) => {
        const n = Number(getTotal(row))
        return sum + (Number.isNaN(n) ? 0 : n)
    }, 0)
